document.addEventListener("DOMContentLoaded", () => {
  const carousel_min_heights = document.querySelectorAll('.js-carousel-min-height');
  carousel_min_heights.forEach((carousel) => {
    carousel.addEventListener('slid.bs.carousel', () => {
      const carousel_inner = carousel.querySelector('.carousel-inner');
      if(!carousel_inner.dataset.minHeight || parseInt(carousel_inner.dataset.minHeight) < carousel_inner.offsetHeight) {
        carousel_inner.dataset.minHeight = carousel_inner.offsetHeight;
        carousel_inner.style['min-height'] = `${carousel_inner.dataset.minHeight}px`;
      }
    });
  });
});